import './App.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router } from 'react-router-dom';
import Routes from './navigation/Routes';
import { AuthProvider } from './context/authContext';
import React from 'react';
import { useEffect } from 'react';

function App() {

  useEffect(() => {
    const title = process.env.REACT_APP_PRODUCT_NAME || 'Bounceback';
    document.title = title;

    // Dynamically change meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", process.env.REACT_APP_PRODUCT_DESCRIPTION || "Bounceback");
    } else {
      const newMetaDescription = document.createElement('meta');
      newMetaDescription.name = "description";
      newMetaDescription.content = process.env.REACT_APP_PRODUCT_DESCRIPTION || "Bounceback";
      document.head.appendChild(newMetaDescription);
    }

  }, []);

  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
